// Importuri din biblioteci externe
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";

// Importuri din componente interne
import MeniuLateral from "./MeniuLateral";
import PrivireGenerala from "./Categorii/PrivireGenerala";
import DosarSocial from "./Categorii/Subcategorii/DosarSocial";
import DosarPsihologic from "./Categorii/Subcategorii/DosarPsihologic";
import DosarMedical from "./Categorii/Subcategorii/DosarMedical";
import DosarJuridic from "./Categorii/Subcategorii/DosarJuridic";
import DosarAngajari from "./Categorii/Subcategorii/DosarAngajari";
import DosarFinanciar from "./Categorii/Subcategorii/DosarFinanciar";
import GalerieFoto from "./Categorii/Subcategorii/GalerieFoto";
import Contact from "./Categorii/Subcategorii/Contact";
import DatePersonale from "./Categorii/Subcategorii/DatePersonale";
import IstoricActiuni from "./Categorii/IstoricActiuni";
import Reintegrare from "./Categorii/Reintegrare";
import Actiuni from "./Categorii/Actiuni";

// Importuri de fișiere de stiluri
import "./stiluri/BeneficiarDetalii.css";

// Componenta pentru detalii beneficiar
const BeneficiarDetalii = () => {
  // Preluăm parametrul id din URL pentru a identifica beneficiarul
  const { id } = useParams();
  const db = getFirestore();

  // State pentru a stoca detaliile beneficiarului și pentru a controla secțiunea selectată
  const [beneficiar, setBeneficiar] = useState(null);
  const [sectiuneSelectata, setSectiuneSelectata] = useState("privireGenerala");
  const [setEditMode] = useState(false);

  // useEffect pentru a încărca detaliile beneficiarului din Firestore
  useEffect(() => {
    const fetchBeneficiarDetails = async () => {
      // Obținem referința la documentul beneficiarului din Firestore
      const beneficiaryRef = doc(db, "Beneficiari", id); // "beneficiari" este colecția, iar id este documentul
      const snapshot = await getDoc(beneficiaryRef);

      if (snapshot.exists()) {
        setBeneficiar(snapshot.data()); // Dacă documentul există, actualizăm starea
      } else {
        console.log("Beneficiarul nu a fost găsit.");
      }
    };

    fetchBeneficiarDetails(); // Apelăm funcția pentru a încărca datele beneficiarului
  }, [id, db]); // Dependență pentru a reîncărca datele când se schimbă id-ul

  // Funcție pentru a selecta secțiunea activă
  const handleSectiuneSelectata = (sectiune) => {
    setSectiuneSelectata(sectiune); // Actualizăm secțiunea selectată
  };

  // Dacă nu avem date despre beneficiar, afișăm un mesaj de încărcare
  if (!beneficiar) {
    return <p>Se încarcă detaliile...</p>; // Loading state
  }

  // Componenta afisarea detaliilor beneficiarului și a altor secțiuni

  return (
    <div className="pagina-container-detalii">
      <div className="continut-detalii">
        <MeniuLateral onSectiuneSelectata={handleSectiuneSelectata} />{" "}
        <div className="detalii-container">
          {sectiuneSelectata === "privireGenerala" && (
            <PrivireGenerala beneficiar={beneficiar} />
          )}

          {sectiuneSelectata === "datePersonale" && (
            <div className="detalii-grid">
              <div className="detalii-col">
                <>
                  <DatePersonale
                    beneficiar={beneficiar}
                    setBeneficiar={setBeneficiar}
                    id={id} 
                  />
                </>
              </div>
            </div>
          )}

          {sectiuneSelectata === "albumfoto" && (
            <div className="detalii-grid">
              <GalerieFoto
                sectiuneSelectata={sectiuneSelectata}
                beneficiar={beneficiar}
                id={id}
              />
            </div>
          )}
          {sectiuneSelectata === "contact" && (
            <div className="detalii-grid">
              <Contact beneficiar={beneficiar} setBeneficiar={setBeneficiar} />

              
            </div>
          )}
          {sectiuneSelectata === "dosarSocial" && (
            <div className="detalii-grid">
              <DosarSocial beneficiar={beneficiar} 
              id={id}
              
              />
            </div>
          )}

          {sectiuneSelectata === "dosarPsihologic" && (
            <div className="detalii-grid">
              <DosarPsihologic beneficiar={beneficiar}
              id={id}
              />
              
            </div>
          )}

          {sectiuneSelectata === "dosarAngajari" && (
            <div className="detalii-grid">
              {sectiuneSelectata === "dosarAngajari" && (
                <DosarAngajari beneficiar={beneficiar} 
                id={id}/>
              )}
            </div>
          )}

          {sectiuneSelectata === "dosarFinanciar" && (
            <div className="detalii-grid">
              {sectiuneSelectata === "dosarFinanciar" && (
                <DosarFinanciar beneficiar={beneficiar}
                id={id} />
              )}
            </div>
          )}

          {sectiuneSelectata === "dosarJuridic" && (
            <div className="detalii-grid">
              <DosarJuridic beneficiar={beneficiar}
              id={id}  />
            </div>
          )}

          {sectiuneSelectata === "dosarMedical" && (
            <div className="detalii-grid">
              {sectiuneSelectata === "dosarMedical" && (
                <DosarMedical
                  beneficiar={beneficiar}
                  setBeneficiar={setBeneficiar}
                  id={id}
                  setEditMode={setEditMode}
                />
              )}
            </div>
          )}

          {sectiuneSelectata === "IstoricActiuni" && (
            <div className="detalii-grid">
              {sectiuneSelectata === "IstoricActiuni" && <IstoricActiuni />}
            </div>
          )}
          {sectiuneSelectata === "Reintegrare" && (
            <div className="detalii-grid">
              {sectiuneSelectata === "Reintegrare" && <Reintegrare />}
            </div>
          )}
          {sectiuneSelectata === "Actiuni" && (
            <div className="detalii-grid">
                  <Actiuni beneficiar={beneficiar} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BeneficiarDetalii;
